export default {"src":"/_next/static/media/weather-forecast.a3f3a379.svg","height":54,"width":50,"blurWidth":0,"blurHeight":0};